import React from "react";
import { IconType } from "../../type/icon_type";

// 카리페이 공식 로고 'cari pay' (기본 톤) — 결제 페이지 헤더용
// 원본: goat-design packages/logos/src/svg/pay.svg (viewBox 926x175, 심볼 #3B82F6 · 글자 #1C252D). 경로 수정 금지.
// 비율 926:175 ≈ 5.29:1 — 높이 28 이면 너비 148.
const CariPayLogoBlack = (props: IconType) => {
  return (
    <svg
      width={props.width || "148"}
      height={props.height || "28"}
      viewBox="0 0 926 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="카리페이"
      style={props.style}
    >
      <path
        d="M246.569 104.086C263.389 118.151 287.315 113.785 299.773 97.08L315.335 108.111C305.314 122.913 288.877 130.738 271.121 131.42C242.23 132.53 218.223 112.052 214.985 84.2538C211.701 56.0726 230.506 30.4777 259.036 25.3194C280.788 21.3878 302.979 29.8468 315.653 48.6865L299.804 59.4741C291.237 47.8346 278.326 41.9139 264.505 43.8629C250.918 45.7783 240.366 54.982 236.361 66.6359C231.661 80.3141 235.258 94.6313 246.569 104.088V104.086Z"
        fill="#1C252D"
      />
      <path
        d="M468.687 71.8423L468.107 131.451L447.634 131.462L447.993 73.4374C448.167 45.1841 471.308 24.1054 499.667 24.0222L499.792 43.3808C483.536 43.2959 468.853 54.7321 468.687 71.8407V71.8423Z"
        fill="#1C252D"
      />
      <path
        d="M161.253 94.6457C160.138 93.8514 159.823 92.3765 160.51 91.2186C163.239 86.6095 169.414 74.4703 172.185 57.9895C175.111 40.5735 169.441 14.3204 145.855 17.0878C134.52 18.4138 124.382 26.5717 118.128 34.9523C114.94 39.2234 112.483 43.6387 110.765 48.7666C107.966 57.1263 107.072 65.9777 107.434 74.7986L107.426 74.7938C107.426 74.7938 106.689 135.384 154.914 138.602L154.887 138.552C162.573 138.992 174.307 136.07 178.836 129.005C188.962 113.212 167.409 99.029 161.253 94.6474V94.6457Z"
        fill="#3B82F6"
      />
      <path
        d="M0.224845 38.6244C0.224845 38.6244 0.0983284 39.5308 0.0470811 41.1579C-0.135487 45.2977 0.221642 49.4439 1.16331 53.4348C3.5399 65.2633 14.6958 82.5625 34.7079 97.2416C35.2075 97.6084 35.2748 98.3515 34.8536 98.8111C32.7685 101.088 29.8266 103.857 27.9448 106.236C19.718 116.632 11.7026 132.559 18.3648 145.563C21.7183 152.11 30.9732 155.34 37.7923 155.471C54.0377 155.784 65.8374 149.557 76.9645 137.25C88.0867 124.942 94.728 108.735 97.489 92.0961C101.028 70.782 98.1712 47.82 86.836 29.6785C75.5696 11.6523 52.7421 -3.05889 31.356 0.547633C13.8614 3.49755 2.25552 20.2682 0.29531 37.9437L0.224845 38.6244Z"
        fill="#3B82F6"
      />
      <path
        d="M412.343 131.462L412.127 115.705C405.01 123.516 396.908 128.583 386.809 130.434C353.553 136.531 323.569 111.677 323.709 78.0144C323.844 45.7078 351.599 21.2917 384.093 25.1528C409.537 28.1764 430.043 48.3406 431.226 74.5921L431.59 131.356L412.343 131.462ZM361.788 108.475C379.644 117.521 400.534 109.836 408.532 92.9338C416.855 75.3447 409.478 54.5848 391.582 46.6831C374.909 39.3211 354.402 46.2187 346.678 63.7917C339.362 80.4342 345.107 100.024 361.789 108.475H361.788Z"
        fill="#1C252D"
      />
      <path
        d="M537.509 131.462H515.804V52.088C515.804 41.0395 524.738 32.0728 535.787 32.0311C536.706 32.0279 537.454 32.771 537.454 33.6903L537.51 131.462H537.509Z"
        fill="#1C252D"
      />
      <path
        d="M522.527 0.856752C528.575 -1.59031 534.85 1.42528 536.905 7.05287C538.9 12.5139 536.49 18.8606 530.681 21.0738C525.47 23.0596 519.327 20.896 516.881 15.9026C514.169 10.3631 516.254 3.39349 522.527 0.856752Z"
        fill="#1C252D"
      />
      <path
        d="M806.935 131.148L806.719 115.43C799.595 123.248 791.486 128.318 781.377 130.173C748.089 136.276 718.077 111.399 718.216 77.7038C718.351 45.3667 746.133 20.9266 778.656 24.7925C804.124 27.8193 824.649 48.0027 825.834 74.2782L826.198 131.044L806.932 131.15L806.935 131.148ZM756.33 108.193C774.204 117.247 795.113 109.556 803.117 92.6375C811.448 75.0325 804.065 54.2517 786.151 46.342C769.462 38.9736 748.936 45.8776 741.204 63.4666C733.88 80.1252 739.631 99.7321 756.33 108.193Z"
        fill="#1C252D"
      />
      <path
        d="M621.7 117.134L621.644 164.416L602.114 164.59L602.411 74.3101C602.497 47.7432 624.155 26.5637 649.974 24.2752C667.562 22.7169 683.509 28.3734 695.194 40.6247C706.553 52.5332 711.675 69.1117 709.011 86.073C704.476 114.96 677.935 134.406 649.046 130.66C638.449 129.286 629.503 124.878 621.7 117.132V117.134ZM634.085 103.72C647.497 114.972 666.62 113.686 678.732 102.748C691.278 91.4187 693.536 72.4989 684.598 58.6989C675.334 44.3929 657.091 38.9031 641.402 46.0729C630.464 51.0711 623.473 61.4455 622.005 72.1738C620.347 84.297 624.458 95.6466 634.083 103.721L634.085 103.72Z"
        fill="#1C252D"
      />
      <path
        d="M873.864 154.605C867.991 168.528 854.149 175.666 840.252 174.902L840.143 156.524C847.931 156.882 853.898 152.56 856.768 145.656L865.36 125L825.774 32.2153L846.821 32.0311L875.784 100.363L904.04 32.2585L925.46 32.2826L873.864 154.605Z"
        fill="#1C252D"
      />
    </svg>
  );
};

export default CariPayLogoBlack;
